import { addLocalDays, startOfLocalDay } from '../../../../Utils/dates/localDay';
import { daysAgoText } from '../../../../Utils/dates/relativeDay';

/** API rows ({athlete, lastWorkout?}) -> view rows. Components never read raw API fields. */
export const toAthleteActivityRows = data =>
    (data || [])
        .filter(r => r && r.athlete)
        .map(r => ({
            id: r.athlete._id,
            firstName: r.athlete.firstName,
            lastName: r.athlete.lastName,
            email: r.athlete.email,
            currentCSS: typeof r.athlete.currentCSS === 'number' ? r.athlete.currentCSS : null,
            lastWorkout: r.lastWorkout
                ? {
                      id: r.lastWorkout._id,
                      workoutStart: r.lastWorkout.workoutStart,
                      volume: typeof r.lastWorkout.volume === 'number' ? r.lastWorkout.volume : null
                  }
                : null
        }));

const fullName = row => `${row.firstName || ''} ${row.lastName || ''}`.trim();
export const initials = row =>
    `${(row.firstName || '').charAt(0)}${(row.lastName || '').charAt(0)}`.toUpperCase();

// "Active last 7 days" = today plus the 6 previous LOCAL days.
const isActive = (row, now) =>
    !!row.lastWorkout &&
    new Date(row.lastWorkout.workoutStart) >= addLocalDays(startOfLocalDay(now), -6);

const matchesStatus = (row, status, now) =>
    status === 'all' ||
    (status === 'active7' ? isActive(row, now) : !row.lastWorkout);

const byWorkoutThenName = sign => (a, b) => {
    // athletes without a completed workout sort as "longest since": last in recent, first in oldest
    const ta = a.lastWorkout ? new Date(a.lastWorkout.workoutStart).getTime() : -Infinity;
    const tb = b.lastWorkout ? new Date(b.lastWorkout.workoutStart).getTime() : -Infinity;
    if (ta !== tb) return sign * (ta > tb ? -1 : 1);
    return fullName(a).localeCompare(fullName(b));
};

/**
 * Pure filter/sort/search. Counts follow the search (not the status chip), as in the mock.
 * `now` is always a parameter.
 */
export const buildActivityView = (rows, { status, sort, query }, now) => {
    const q = (query || '').trim().toLowerCase();
    const found = rows.filter(
        r => !q || `${fullName(r)} ${r.email || ''}`.toLowerCase().includes(q)
    );
    const counts = {
        all: found.length,
        active7: found.filter(r => isActive(r, now)).length,
        none: found.filter(r => !r.lastWorkout).length
    };
    const visible = found
        .filter(r => matchesStatus(r, status, now))
        .sort(byWorkoutThenName(sort === 'oldest' ? -1 : 1));
    return { visible, counts, total: rows.length };
};

export const sinceText = (row, now) =>
    row.lastWorkout ? daysAgoText(row.lastWorkout.workoutStart, now) : 'No completed workout yet';
